import { Component, Input, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { TranslocoModule, TRANSLOCO_SCOPE } from '@jsverse/transloco';
import { DeviceSettingsService } from '../../library/device-settings.service';
import { AmplitudeService } from 'src/app/services/external-tools/amplitude.service';
import { ControlService } from '../../library/control.service';
import { AmplitudeTrackingEvents } from 'src/app/utils/enums/amplitude/amplitudeTrackingEvents.enum';
import { CallStoreService } from '../../library/call-store/call-store.service';
import { AppConstants } from 'src/app/app-constants';
import { DeviceSettingsDiagnosticComponent } from '../device-settings-diagnostic/device-settings-diagnostic.component';
import { ButtonComponent } from 'src/app/components/shared/button/button.component';

@Component({
  selector: 'app-device-settings-content',
  templateUrl: './device-settings-content.component.html',
  styleUrls: ['./device-settings-content.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    MatSelectModule,
    TranslocoModule,
    DeviceSettingsDiagnosticComponent,
    ButtonComponent,
  ],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: 'settings'
    },
  ]
})
export class DeviceSettingsContentComponent implements OnInit, OnDestroy {
  @Input() deviceSettingsService: DeviceSettingsService | undefined;
  @Output() diagnosticRunningChange = new EventEmitter<boolean>();
  isTavusCall: boolean = false;

  constructor(
    private amplitudeService: AmplitudeService,
    private controlService: ControlService,
    private callStore: CallStoreService,
  ) { }

  ngOnInit(): void {
    this.isTavusCall = this.controlService?.isRealTimeCall;
  }

  ngOnDestroy(): void {
    if (this.deviceSettingsService) {
      this.deviceSettingsService.stopDeviceSettings(false);
    }
  }

  public sendAmplitudeSelectMicEvent(): void {
    // Sending the Event of Selecting Microphone
    this.amplitudeService.trackEvent(AmplitudeTrackingEvents.DEVICE_SETTINGS_CLICK_SELECT_MICROPHONE, {
      'microphone_type': this.deviceSettingsService?.audioDeviceSelected,
      'call_type': this.controlService?.callType,
    });
  }

  public sendAmplitudeSelectCamEvent(): void {
    // Sending the Event of Selecting Camera
    this.amplitudeService.trackEvent(AmplitudeTrackingEvents.DEVICE_SETTINGS_CLICK_SELECT_CAMERA, {
      'microphone_type': this.deviceSettingsService?.audioDeviceSelected,
      'call_type': this.controlService?.callType,
    });
  }

  public handleSelectMicClick(): void {
    this.sendAmplitudeSelectMicEvent();
    this.deviceSettingsService?.setAudioDevice();
  }

  public handleSelectCamClick(): void {
    this.sendAmplitudeSelectCamEvent();
    this.deviceSettingsService?.setVideoDevice();
  }

  get isCallActive(): boolean {
    const currentView = this.callStore.getCurrentView();
    const isPracticeView = currentView === AppConstants.VIEW_PRACTICE;
    const isCallEnded = this.callStore.getDisplayPostCall();
    return isPracticeView && !isCallEnded;
  }
}
